var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 8,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.25 88.4101V131.59C78.25 133.44 79.75 134.95 81.61 134.95H138.4C140.25 134.95 141.76 133.45 141.76 131.59V93.9601C141.76 92.1101 140.26 90.6001 138.4 90.6001H109.77C108.77 90.6001 107.83 90.1101 107.27 89.2901L104.7 86.3701C104.13 85.5501 103.2 85.0601 102.2 85.0601H81.61C79.76 85.0601 78.25 86.5601 78.25 88.4201V88.4101Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.75 103.15C141.75 100.39 139.51 98.15 136.75 98.15H83.25C80.49 98.15 78.25 100.39 78.25 103.15V131.59C78.25 133.44 79.75 134.95 81.61 134.95H138.4C140.25 134.95 141.76 133.45 141.76 131.59V103.15H141.75Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.63 116.26L124.78 112.56L129.22 117L125.53 123.15H125.52C126.18 124.31 126.71 125.58 127.09 126.91L134.05 128.64V134.92L133.96 134.94",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.64 116.27C118.64 116.27 118.63 116.27 118.63 116.26C117.46 115.6 116.21 115.07 114.87 114.69L113.14 107.73H106.86L105.13 114.69C103.79 115.07 102.53 115.6 101.36 116.27L95.2099 112.56L90.7799 117L94.4699 123.15H94.4799C93.8099 124.31 93.2899 125.58 92.9099 126.91L85.9399 128.64V134.92L86.0299 134.94",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.81 134.95C118.2 133.98 118.43 132.91 118.43 131.79C118.43 127.14 114.66 123.36 110 123.36C105.34 123.36 101.59 127.13 101.59 131.79C101.59 132.91 101.81 133.97 102.21 134.95",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowAssets);
export default __webpack_public_path__ + "static/media/icon-flow-assets.baf9046525a2646af7148e46cdcd2eeb.svg";
export { ForwardRef as ReactComponent };